import { createBaseChartConfig } from "../../lib/chart-config-builder";
import { createStandardKpiConfig, transformSimpleData, transformGroupedData } from "../../lib/data-transformer";
/**
 * Transform configurations for each GDA KPI type
 */
export const GDA_KPI_CONFIGS = {
    area: {
        transformData: (data) => {
            const config = createStandardKpiConfig({
                kpiNameField: "title",
                kpiValueField: "total_advised",
                isGrouped: false,
            });
            return transformSimpleData(data, config, "Area");
        },
        chartConfig: createBaseChartConfig(),
    },
    region: {
        transformData: (data) => {
            const config = createStandardKpiConfig({
                kpiNameField: "title",
                kpiValueField: "total_advised",
                isGrouped: true,
                groupLabelGetter: (item) => item.region_name,
            });
            return transformGroupedData(data, config);
        },
        chartConfig: createBaseChartConfig(),
    },
    delegation: {
        transformData: (data) => {
            const config = createStandardKpiConfig({
                kpiNameField: "title",
                kpiValueField: "total_advised",
                isGrouped: true,
                groupLabelGetter: (item) => item.delegation_name,
            });
            return transformGroupedData(data, config);
        },
        chartConfig: createBaseChartConfig(),
    },
    sala: {
        transformData: (data) => {
            const config = createStandardKpiConfig({
                kpiNameField: "title",
                kpiValueField: "total_advised",
                isGrouped: true,
                groupLabelGetter: (item) => `Sala ${item.sala}`,
                filterZeroValues: true,
            });
            return transformGroupedData(data, config);
        },
        chartConfig: createBaseChartConfig(),
    },
    distribuidor: {
        transformData: (data) => {
            const config = createStandardKpiConfig({
                kpiNameField: "title",
                kpiValueField: "total_advised",
                isGrouped: true,
                groupLabelGetter: (item) => item.distribuidor || "(Sin nombre)",
                maxItems: 15,
                filterZeroValues: true,
                truncateLabelLength: 25,
            });
            return transformGroupedData(data, config);
        },
        chartConfig: createBaseChartConfig({ maxTicksLimit: 20 }),
    },
};
/**
 * Get transform function and chart config for a specific type
 */
export function getGdaCentersKpiConfig(type) {
    const config = GDA_KPI_CONFIGS[type];
    if (!config) {
        throw new Error(`Unknown GDA Centers KPI type: ${type}`);
    }
    return config;
}
